import React, { Component } from 'react';
import './Footer.css';
 

class Footer extends Component {
  render() {
    return (
         <div className="footer">
            <div>&#169; {new Date().getFullYear()} Copyright &nbsp;&nbsp; | &nbsp;&nbsp; All rights reserved &nbsp;&nbsp; | &nbsp;&nbsp; Privacy Policy | &nbsp;&nbsp; Legal    </div>
        </div>
     
    );
  }
}

export default Footer;


// WEBPACK FOOTER //
// ./src/components/Footer.js